"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyLabel = exports.Currency = void 0;
require("@pulse-web-ui/tooltip");
require("react");
var Currency;
(function (Currency) {
    Currency["RUB"] = "RUB";
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
var CurrencyLabel;
(function (CurrencyLabel) {
    CurrencyLabel["RUB"] = "\u20BD";
    CurrencyLabel["EUR"] = "\u20AC";
    CurrencyLabel["USD"] = "$";
})(CurrencyLabel = exports.CurrencyLabel || (exports.CurrencyLabel = {}));
